// src/utils/helpers.js

// * UTILIDAD PRINCIPAL - Separa solo los campos necesarios de un objeto grande al crear o editar un registro de propiedad
export function dataToSend(template, fields) {
  return fields.reduce((obj, key) => {
    if (Object.prototype.hasOwnProperty.call(template, key)) {
      obj[key] = template[key];
    }
    return obj;
  }, {});
}

export function hasPremiumAccessHelpers(user) {
  const validPlans = ["pro"];
  const demoStatus = "demo";

  if (!user) return false;

  const plan = user.plan?.toLowerCase();
  const status = user.status_subscription?.toLowerCase();

  return status === demoStatus || validPlans.includes(plan);
}

// ¿La cuenta puede conectar canales/OTAs?
// Requiere un plan PAGADO o una suscripción activa. Las cuentas demo/free NO
// pueden conectar OTAs: deben suscribirse primero (regla de negocio: hoteles y
// apartamentos solo se conectan con las OTAs si están suscritos a un plan).
export function canConnectChannelsHelpers(user) {
  if (!user) return false;
  const plan = String(user.plan || "").toLowerCase();
  const status = String(user.status_subscription || "").toLowerCase();
  // Demo/free NO pueden conectar (deben suscribirse), aunque tengan otros flags.
  if (status === "demo" || status === "demo_expired") return false;
  // Suscripción activa o plan pagado (o una suscripción de Stripe ya creada).
  if (status === "subscribed") return true;
  if (["lite", "pro", "suite", "connect"].includes(plan)) return true;
  if (user.suscription_id_stripe) return true;
  return false;
}

export function isHotelHelpers(property) {
  if (!property) return false;

  if (property.type == "hotel" || property.type == "camping") {
    return true;
  }
  return false;
}

// ==============================
// ✅ NUEVO: País ISO2 -> Moneda ISO3
// ==============================

const EUROPE_ISO2 = new Set([
  // EU + EEA + varios europeos (según tu regla: "si es de Europa => EUR")
  "AL","AD","AT","BA","BE","BG","BY","CH","CY","CZ","DE","DK","EE","ES","FI","FR",
  "GB","GR","HR","HU","IE","IS","IT","LI","LT","LU","LV","MC","MD","ME","MK","MT",
  "NL","NO","PL","PT","RO","RS","RU","SE","SI","SK","SM","TR","UA","VA"
]);

const COUNTRY_TO_CURRENCY = {
  // LATAM fuerte
  CO: "COP",
  BR: "BRL",
  VE: "VES",
  MX: "MXN",
  AR: "ARS",
  CL: "CLP",
  PE: "PEN",
  UY: "UYU",
  PY: "PYG",
  BO: "BOB",
  EC: "USD",
  PA: "USD",
  DO: "DOP",
  CR: "CRC",
  GT: "GTQ",
  HN: "HNL",
  NI: "NIO",
  SV: "USD",

  // Norteamérica / otros comunes
  US: "USD",
  CA: "CAD",
  AU: "AUD",
  NZ: "NZD",
  JP: "JPY",
  CN: "CNY",
  IN: "INR",
  KR: "KRW",
  ZA: "ZAR",
};

export function currencyFromCountryISO2(iso2) {
  const cc = (iso2 || "").toString().trim().toUpperCase();
  if (!cc) return "USD";

  if (COUNTRY_TO_CURRENCY[cc]) return COUNTRY_TO_CURRENCY[cc];
  if (EUROPE_ISO2.has(cc)) return "EUR";

  return "USD";
}

// ✅ Para mostrar “en letras” (y VES como Bs)
export function currencyDisplayLabel(currencyCode) {
  const code = (currencyCode || "").toString().trim().toUpperCase();
  if (!code) return "USD";
  if (code === "VES") return "Bs";
  return code; // EUR, COP, BRL, USD, etc.
}
